// pages/Home.js
import TopBar from "../components/TopBar";
import Header from "../components/Header";
import Hero from "../components/Hero";
import VideoSection from "../components/VideoSection";
import Services from "../components/Services";
import Contact from "../components/Contact";
import PreFooter from "../components/PreFooter";
import Footer from "../components/Footer";

function Home() {
  return (
    <>
      <TopBar />
      <Header activePage="home" />
      <Hero />
      <VideoSection />
      <Services />
      <Contact />
      <PreFooter />
      <Footer />
    </>
  );
}

export default Home;